import { matchPath } from 'react-router';
import useReactRouterContext from '@medflex/hooks/useReactRouterContext';
import isAnySessionChatId from '@medflex/utils/isAnySessionChatId';

const useSelectedSessionChatId = () => {
  const { location } = useReactRouterContext();
  const matchesChat = matchPath(location.pathname, { path: '/chat/:sessionChatId' });
  const { sessionChatId = undefined } = (matchesChat && matchesChat.params) || {};

  if (sessionChatId && isAnySessionChatId(sessionChatId)) {
    return sessionChatId;
  }
  return null;
};

export default useSelectedSessionChatId;
